import React from "react";
import Invoices from "../components/Invoices";

interface GroupSubscriptionInvoicesProps {}

const GroupSubscriptionInvoices: React.FC<GroupSubscriptionInvoicesProps> = () => {
  return <Invoices />;
};

export default GroupSubscriptionInvoices;
